module.exports = __webpack_public_path__ + "img/icono_correo.401b319f.png";